/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-cycle */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { DialogComponent, DialogUtility } from '@syncfusion/ej2-react-popups';
// import ReactDOM from 'react-dom';
import { KanbanComponent, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-react-kanban';
import { TextBoxComponent, UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { ButtonComponent, SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { addClass } from '@syncfusion/ej2-base';
import { Query } from '@syncfusion/ej2-data';
import { useStateContext } from '../contexts/ContextProvider';
import { inventoryGrid } from '../data/dummy';
import armband from '../data/watchsketch.png';
import { Header, DevLog } from '../components';
// import { Methods } from './Methods';
import mappin from '../data/mappin.png';
import compliance from '../data/compliance.png';
import scribeHow from '../data/scribehow.png';
// import complianceOFF from '../data/compliance-3.png';
/*
                    : (
                      <img src={complianceOFF} width={40} />
                    )}
*/
import './inventory.css';
import './Zackat.css';

const Inventory = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=card');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { boss, isMobile } = useStateContext();

  const { REACT_APP_API_ENDPOINT } = process.env;
  const valuerules = { required: true };
  // const { loading, data } = Methods('inventory', 'GET', '') || {};
  const [loading, setLoading] = useState(true);
  const [refetch, setRefetch] = useState(false);
  const [data, setData] = useState([]);
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  const [crudImport, setCrudImport] = useState(false);
  useEffect(() => {
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Create')) {
      setCrudCreate(true);
    }
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Import')) {
      setCrudImport(true);
    }
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Update')) {
      setCrudUpdate(true);
    }
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Delete')) {
      setCrudDelete(true);
    }
  }, [data]);
  let orgObj;
  let kanbanObj;
  let priorityObj;
  let textBoxObj;
  const organization = JSON.parse(localStorage.getItem('organization'));
  // Too long to Render
  const [expanded, setExpanded] = useState(true);
  const [logDialog, setLogDialog] = useState(true);
  const handleLogDialogClick = () => {
    setLogDialog(!logDialog);
  };
  const logbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleLogDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },

  ];
  function eventHandler(b, cmd) {
    navigate(`../events?device=${b.device}`);
  }
  const [inventory, setInventory] = useState(null);

  const logTemplate = (b) => (
    <DevLog props={inventory} />
  );
  function logHandler(b, cmd) {
    setInventory(b);
    setLogDialog(!logDialog);
  }
  function setUserPreferences(pref, val) {
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.card) {
      data.user.preferences.card = {};
    }
    if (pref === 'expanded') {
      data.user.preferences.card = { expanded: val };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        }
      })
      .catch((error) => {
        DialogUtility.alert('error setting user preferences');
      });
  }

  function changeExpanded() {
    setExpanded(!expanded);
    setUserPreferences('expanded', !expanded);
    const swimlaneHeaders = document.querySelectorAll('.e-swimlane-header .e-item-count');
    for (let i = 0; i < swimlaneHeaders.length; i += 1) {
      const swim = swimlaneHeaders[i].querySelector('.e-icons .e-swimlane-row-expand');
      if (swim) {
        // Not finding this, so we will click at the parent level
        swim.click();
      } else {
        swimlaneHeaders[i].click();
      }
    }
  }
  const orgData = [];
  useEffect(() => {
    const fetchData = async () => {
      if (organization && organization.id) {
        usr.organizationid = organization.id;
      }
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/inventory?${query}`;
      await axios({
        url,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.data && response.data.user && response.data.user.preferences && response.data.user.preferences.card) {
            if (response.data.user.preferences.card.expanded) {
              // setExpanded(response.data.user.preferences.card.expanded);
              // Render Time is too long
              setExpanded(true);
            } else {
              setExpanded(true);
            }
          } else {
            setExpanded(true);
          }
          if (response && response.data) {
            setData(response.data);
          } else {
            setData([]);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error(error.message);
        });
    };
    fetchData();
  }, [refetch]);

  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.organization) {
    data.organization.forEach((element) => {
      orgData.push({ id: element._id, value: element.title });
    });
  }
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  function changeOrganization(e) {
    let found = false;
    const invArray = [];
    if (confirm(`Change Organization to ${e.target.properties.text} ID: ${e.target.properties.value}?`)) {
      for (let i = 0; i < data.inventory.length; i += 1) {
        if (e.target.id === data.inventory[i]._id) {
          found = true;
          data.inventory[i].organizationid = e.target.properties.value;
          invArray.push(data.inventory[i]);
          break;
        }
      }
      if (found) {
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(invArray),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
          })
          .catch((error) => {
            console.error('error');
          });
      } else {
        window.location.reload();
        return false;
      }
    } else {
      window.location.reload();
      return false;
    }
    return true;
  }
  const actionComplete = (args) => {
    /** Set initial Focus */
    if (args.requestType === 'cardCreated') {
      if (args.addedRecords) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        const result = orgData.find(({ value }) => value === args.addedRecords[0].organization);
        if (!result) {
          args.addedRecords[0].organizationid = organization.id;
          args.addedRecords[0].organization = organization.name;
        } else {
          args.addedRecords[0].organizationid = result.id;
        }
        if (confirm(`Would you really like to add this entry for Organization ${args.addedRecords[0].organization}, with a Status of ${args.addedRecords[0].status}?`)) {
          args.addedRecords[0].simstatus = { status: args.addedRecords[0].status };
          if (args.addedRecords[0].device && args.addedRecords[0].device.length >= 19 && args.addedRecords[0].device.length <= 20) {
            if (isNaN(args.addedRecords[0].device)) {
              DialogUtility.alert(`Invalid Device ID ${args.addedRecords[0].device}`);
              setRefetch(!refetch);
              return;
            }
          } else {
            DialogUtility.alert(`Invalid Device ID ${args.addedRecords[0].device}`);
            setRefetch(!refetch);
            return;
          }
          fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(args.addedRecords),

          })
            .then((response) => response.json())
            .then((responseJson) => {
              // args.cancel = true;
            })
            .catch((error) => {
              console.error(error);
            });
        }
      }
    } else if (args.requestType === 'cardChanged') {
      if (args) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.changedRecords),

        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            args.cancel = false;
          })
          .catch((error) => {
            console.error('error');
          });
      }
    } else if (args.requestType === 'cardRemoved') {
      if (args.deletedRecords) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.deletedRecords),

        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            // args.cancel = true;
          })
          .catch((error) => {
            console.error('error');
          });
      }
    }
  };

  function tryRefetching() {
    setRefetch(true);
  }
  function simStatusChange(b) {
    let msg = 'ACTIVATE';
    let state = 'ACTIVATED';
    if (b.simstatus.status === 'ACTIVATED' || b.simstatus.status === 'ACTIVATION_READY' || b.simstatus.status === 'TEST_READY') {
      msg = 'DEACTIVATE';
      state = 'DEACTIVATED';
    }

    if (confirm(`Would you like to ${msg} SIM ${b.device}?`)) {
      b.simstatus.status = state;
      fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(b),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          // The added/edited data will be saved in the Grid
          setTimeout(tryRefetching, 10000);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  function getSimStatus(b) {
    // Set SimStatus to null to fetch from Jasper
    const j = { _id: b._id, simstatus: null };
    fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(b),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        setTimeout(tryRefetching, 10000);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function smsDevice(b, cmd) {
    let message = '';
    if (cmd === 'reset') {
      message = prompt(`Restart device ${b.device} or put device to sleep?`, 'restart');
      if (message && message.length > 0 && message.toLocaleLowerCase() === 'restart') {
        message = '"reset":"restart"';
      } else if (message && message.length > 0 && message.toLocaleLowerCase() === 'sleep') {
        message = '"reset":"sleep"';
      } else {
        return;
      }
    } else if (cmd === 'fota') {
      message = '"fota":"ind"';
      message = confirm(`FOTA device ${b.device}?`);
    } else if (cmd === 'locate') {
      message = '"locate":"query"';
    } else if (cmd === 'rehome') {
      message = prompt(`ReHome device ${b.device} production, staging or development?`, 'production');
      if (!message || message.length === 0) {
        return;
      }
      if (message.includes('.') && !boss) {
        return;
      }
      switch (message.toLocaleLowerCase()) {
        case 'production':
          message = '"srvr": {"url":"bio.zackatlabs.com", "port": "10900"}';
          break;
        case 'staging':
          message = '"srvr": {"url":"biometric.zackatlabs.com", "port": "10900"}';
          break;
        case 'development':
          message = '"srvr": {"url":"biometric.zackat.com", "port": "10900"}';
          break;
        default:
          message = `"srvr":{"url":"${message}", "port": "10900"}`;
          break;
      }
    } else {
      message = prompt(`What SMS would you like to send to ${b.device}?`, '');
    }
    if (!message || message.length === 0) {
      return;
    }
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  }
  function goAssociate(props) {
    localStorage.setItem('currentAssociate', props.resultField[0].name);
    navigate('../associatepage');
  }
  function cardTemplate(props) {
    return (
      <div className="card-template">
        <div
          style={
            {
              border: '2px solid darkgrey',
            }
          }
          className="e-card-content e-card-separator"
        >
          <table className="card-template-wrap">
            <tbody>
              <tr>
                <td className="CardHeader">Associate:</td>
                {props.resultField && props.resultField[0] && props.resultField[0]._id && props.resultField[0].name ? (
                  <td>
                    {/* <Link onClick={localStorage.setItem('currentAssociate', props.resultField[0].name)} to={`/associatepage?id=${props.resultField[0]._id}&name=${props.resultField[0].name}`}> */}
                    {/* <ButtonComponent id="associateGo" iconCss="e-icons e-user" onClick={() => goAssociate(props)} /> */}
                    <div className="flex">
                      <img
                        className="e-card-avatar"
                        src={props.resultField && props.resultField[0] ? props.resultField[0].employeeImage : 'https://monaco.zackat.com/blank.png'}
                        width="50"
                        height="50"
                        title="Click me to go to the associate"
                        onClick={() => { goAssociate(props); }}
                      />
                      {props.skinContact && (<img className="flex" src={compliance} title="compliant" width={40} />)}
                    </div>
                    {props.resultField && props.resultField[0] ? props.resultField[0].name : 'unassigned'}
                  </td>
                ) : (
                  <td>
                    <div className="flex">
                      <img
                        className="e-card-avatar"
                        src={props.resultField && props.resultField[0] ? props.resultField[0].employeeImage : 'https://monaco.zackat.com/blank.png'}
                        width="50"
                        height="50"
                      />
                      {props.skinContact && (<img src={compliance} title="compliant" width={40} />)}
                    </div>
                    {props.resultField && props.resultField[0] ? props.resultField[0].name : 'unassigned'}
                  </td>
                )}
              </tr>
              {props.resultField && props.resultField[0] && props.resultField[0].latlng && props.resultField[0].latlng.latitude !== 0 && props.resultField[0].latlng.longitude !== 0 && (
                <tr>
                  <td className="CardHeader">Location:</td>
                  <td>
                    <Link to={`/basic?id=${props.resultField[0]._id}&lat=${props.resultField[0].latlng.latitude}&lng=${props.resultField[0].latlng.longitude}&name=${props.resultField[0].name}&tabNo=1`}>
                      <img
                        className="w-8 h-8"
                        src={mappin}
                        alt="map"
                      />
                    </Link>
                  </td>
                </tr>
              )}
              <tr>
                <td className="CardHeader">Device:</td>
                <td>{props.device}</td>
              </tr>
              {props.simstatus && (
                <tr>
                  <td className="CardHeader">SIM Status:</td>
                  <td>
                    {props.simstatus.status === 'ACTIVATED' || props.simstatus.status === 'TEST_READY' || props.simstatus.status === 'ACTIVATION_READY' ? (
                      <ButtonComponent id="simstatus" className="e-btn e-success" disabled={!crudUpdate} onClick={() => simStatusChange(props)}>ACTIVE</ButtonComponent>
                    ) : (
                      <ButtonComponent id="simstatus" className="e-btn e-warning" disabled={!crudUpdate} onClick={() => simStatusChange(props)}>INACTIVE</ButtonComponent>
                    )}
                  </td>
                </tr>
              )}
              {props.simstatus && (
                <tr>
                  <td className="CardHeader">SMS:</td>
                  <td>
                    <ButtonComponent id="smsreset" className="e-btn e-danger" disabled={!crudUpdate} onClick={() => smsDevice(props, 'reset')}>Reset</ButtonComponent>
                    &nbsp;<ButtonComponent id="smsfota" className="e-btn e-success" disabled={!crudUpdate} onClick={() => smsDevice(props, 'fota')}>FOTA</ButtonComponent>
                    &nbsp;<ButtonComponent id="sms" className="e-btn e-info" disabled={!crudCreate} onClick={() => smsDevice(props, 'rehome')}>ReHome</ButtonComponent>
                    &nbsp;<ButtonComponent id="sms" className="e-btn e-outline" disabled={!crudUpdate} onClick={() => smsDevice(props, '')}>SMS</ButtonComponent>
                  </td>
                </tr>
              )}
              {props._id && (
                <tr>
                  <td className="CardHeader">EVENTS:</td>
                  <td>
                    &nbsp;<ButtonComponent id="events" className="e-btn e-outline" iconCss="e-custom-events" onClick={() => eventHandler(props, '')}>GET</ButtonComponent>&nbsp;
                    {boss && <ButtonComponent id="devlogs" className="e-btn e-outline" iconCss="e-custom-icon" onClick={() => logHandler(props, '')}>LOGS</ButtonComponent>}
                  </td>
                </tr>
              )}
              {props.simstatus && (
                <tr>
                  <td className="CardHeader">Refresh:</td>
                  <td>
                    <ButtonComponent id="sms" className="e-btn e-link" onClick={() => getSimStatus(props)}>GET {props.simstatus.status ? (`(${props.simstatus.status})`) : ''}</ButtonComponent>
                  </td>
                </tr>
              )}
              <tr>
                <td className="CardHeader">IMEI:</td>
                <td>{props.imei}</td>
              </tr>
              <tr>
                <td className="CardHeader">MSN:</td>
                <td>{props.msn && props.msn !== 'undefined' ? props.msn : ''}</td>
                <td>H2S: {props.h2s && props.h2s !== 'undefined' ? props.h2s : ''}</td>
              </tr>
              <tr>
                <td className="CardHeader">Version:</td>
                <td>{props.version && props.version !== 'undefined' ? props.version : ''}
                </td>
                <td style={{
                  color: props.battery <= 60 ? 'red' // you may use your preferred color hexadecimal instead (ex: #f00)
                    : 'green', // you may use your preferred color hexadecimal instead (#00f)
                }}
                >Battery: {props.battery && props.battery !== 'undefined' ? props.battery : ''}%
                </td>
              </tr>
              <tr>
                <td className="CardHeader">Charger:</td>
                <td>
                  {props.charger && props.charger !== 'undefined' ? props.charger.toUpperCase() : ''}
                </td>
                <td>
                  Compliance: <SwitchComponent id="showMap" checked={props.skinContact} cssClass="compliance-color" disabled />
                </td>
              </tr>
              <tr>
                <td className="CardHeader">RSRP:</td>
                <td style={{
                  // you may use your preferred color hexadecimal instead (ex: #f00)
                  // eslint-disable-next-line no-nested-ternary
                  color: props.rssi >= -90 ? 'green' : props.rssi >= -105 ? '#FFBF00' : props.rssi >= -120 ? 'orange' : 'red',
                }}
                > {props.rssi && props.rssi !== 'undefined' ? props.rssi : ''}dBm
                </td>
                <td>TZ Offset: {props.tzoffset && props.tzoffset !== 'undefined' ? props.tzoffset : ''}
                </td>
              </tr>
              <tr>
                <td className="CardHeader">Organization:</td>
                <td>
                  <DropDownListComponent ref={(orgs) => { orgObj = orgs; }} id={props._id} dataSource={data.organization} fields={organizations.params.fields} onChange={changeOrganization} value={props.organizationid} placeholder="Select an Organization" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (data.role && data.role.inventory && !data.role.inventory.permissions.includes('Read')) {
    return <p>Not authorized...</p>;
  }
  const fields = [
    { text: 'Device', key: 'device', type: 'TextBox' },
    { text: 'Status', key: 'status', type: 'DropDown' },
    { text: 'Version', key: 'version', type: 'TextBox' },
    { text: 'RSRP', key: 'rssi', type: 'TextArea' },
    { text: 'IMEI', key: 'imei', type: 'TextBox' },
    { text: 'MSN', key: 'msn', type: 'TextBox' },
    { text: 'H2S', key: 'h2s', type: 'TextBox' },
  ];
  function columnTemplate(props) {
    return (
      <div className="header-template-wrap">
        <div className={`header-icon e-icons ${props.keyField}`} />
        <div className="header-text">{props.headerText}</div>
      </div>
    );
  }

  function cardRendered(args) {
    const val = args.data.status;
    addClass([args.element], val);
  }
  const onFileUpload = (args) => {
    // add addition data as key-value pair.
    args.customFormData = [{ organizationid: data.user.organizationid }];
  };

  let uploadObj;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/inventoryremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/inventoryupload`,
  };

  function searchClick(e) {
    const searchValue = e.value;
    let searchQuery = new Query();
    if (searchValue !== '') {
      searchQuery = new Query().search(searchValue, ['device', 'imei', 'msn'], 'contains', true);
    }
    kanbanObj.query = searchQuery;
  }

  function reset() {
    textBoxObj.value = '';
    kanbanObj.query = new Query();
  }
  const bindData = () => {
    const swimlaneHeaders = document.querySelectorAll('.e-swimlane-header .e-item-count');
    for (let i = 0; i < swimlaneHeaders.length; i += 1) {
      const swim = swimlaneHeaders[i].querySelector('.e-icons .e-swimlane-row-expand');
      if (swim) {
        // Not finding this, so we will click at the parent level
        swim.click();
      } else {
        swimlaneHeaders[i].click();
      }
    }
  };
  function change(args) {
    let filterQuery = new Query();
    if (args.value !== 'None') {
      if (args.element.id === 'version') {
        filterQuery = new Query().where('version', 'equal', args.value);
      }
    }
    kanbanObj.query = filterQuery;
  }
  const priorityData = ['None', '1.0', '1.1', '1.2', '1.3'];

  function completeUpload(args) {
    DialogUtility.alert(`Upload completed ${args.fileData[0].status}`);
    setRefetch(!refetch);
  }
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };
  const currentThemeColor = localStorage.getItem('colorMode');
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <img
        className="w-20"
        src={armband}
        alt="arm band"
      />
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/Inventory_card_workflows__BS1d4XDaSruV70NyCPy1qA"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Inventory" title="Card" />
      </div>
      <div style={{
        backgroundColor: currentThemeColor,
        textAlign: 'right',
        marginTop: '-40px',
      }}
      >
        <div id="droparea">
          {crudImport && isMobile && (
            <div className="control-section accordion-control-section" style={{ width: '25%' }}>
              <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
                <AccordionComponent>
                  <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                    <div className="e-input-group">
                      <div className="mt-4"> Import </div>
                    </div>
                    <div className="mt-2 e-input-group">
                      <UploaderComponent
                        id="fileupload"
                        type="file"
                        ref={(uplaod) => { uploadObj = uplaod; }}
                        asyncSettings={path}
                        buttons={buttons}
                        multiple={false}
                        actionComplete={completeUpload}
                        autoUpload={false}
                        uploading={onFileUpload}
                        allowedExtensions=".csv"
                      />
                    </div>
                  </div>
                </AccordionComponent>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="control-wrapper">
        <div>
          <div style={{ border: '1pxtip solid black', width: '100%' }}>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '200px' }}>
                    Search:<TextBoxComponent id="search" ref={(kanban) => { textBoxObj = kanban; }} showClearButton placeholder="Enter search text" input={searchClick} />
                  </td>
                  <td style={{ width: '200px' }}>
                    <ButtonComponent id="reset" className="e-btn" onClick={reset}>Reset</ButtonComponent>
                  </td>
                  <td style={{ width: '200px' }}>
                    Filter:<DropDownListComponent id="verion" ref={(kanbant) => { priorityObj = kanbant; }} dataSource={priorityData} change={change} placeholder="Select a version" />
                  </td>
                  {/*
                  <td style={{ width: '200px' }}>
                    <div>
                      <label htmlFor="showDisplay" style={{ padding: '10px 40px 10px 0' }}>
                        Collapse
                      </label>
                      <SwitchComponent id="showDisplay" checked={expanded} cssClass="bar-color handle-color" onChange={changeExpanded} />
                    </div>
                  </td>
                  */}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <KanbanComponent
          cssClass="kanban-overview"
          id="inventory"
          keyField="status"
          dataSource={data.inventory}
          actionComplete={actionComplete}
          dialogSettings={{ fields, className: 'e-dialog-delete' }}
          allowDragAndDrop
          swimlaneSettings={{ keyField: 'organization', allowDragAndDrop: true, sortDirection: 'Ascending' }}
          enablePersistence={false}
          enableVirtualization={false}
          dataBound={expanded ? bindData : null}
          ref={(kanban) => { kanbanObj = kanban; }}
          cardSettings={{
            headerField: 'device',
            contentField: 'imei',
            template: cardTemplate,
          }}
        >
          <ColumnsDirective>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            {inventoryGrid.map((item, index) => (
              <ColumnDirective
                key={index}
                {...item}
                template={columnTemplate}
                showAddButton
              />
            ))}
          </ColumnsDirective>
        </KanbanComponent>
      </div>
      {!logDialog && (
        <DialogComponent
          header="Device Logs"
          content={logTemplate}
          buttons={logbuttons}
          width="95%"
          height="95%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setLogDialog(!logDialog); }}
          close={() => { setLogDialog(!logDialog); }}
        />
      )}
    </div>
  );
};
export default Inventory;
